import { map } from 'rxjs/operators';
import {
  emptyCollectionStream,
  toCollectionStream,
} from 'streams/utils/streamUtils';
import { ResourceType, APIBookmarkAttributes } from '@ardoq/api-types';
import {
  reducedStream,
  streamReducer,
  toPersistentStream,
} from '@ardoq/rxbeach';
import { fetchAllReducer, websocketReducer } from 'streams/crud/reducers';
import { filterResourceType, websocket$ } from 'sync/websocket$';
import {
  removeEntityById,
  returnPayload,
  updateEntity,
} from '@ardoq/common-helpers';

export const bookmarksNamespace = 'bookmarks';

const handleBookmarkAdded = (
  state: APIBookmarkAttributes[],
  bookmark: APIBookmarkAttributes
): APIBookmarkAttributes[] => [...state, bookmark];

const bookmarksList$ = reducedStream<APIBookmarkAttributes[]>(
  'bookmarksList$',
  [],
  [
    fetchAllReducer(returnPayload<APIBookmarkAttributes[]>),
    streamReducer(
      websocket$.pipe(
        filterResourceType<APIBookmarkAttributes>(ResourceType.BOOKMARK)
      ),
      websocketReducer({
        create: handleBookmarkAdded,
        update: updateEntity,
        delete: removeEntityById,
      })
    ),
  ],
  { namespace: bookmarksNamespace }
);

export const bookmarks$ = toPersistentStream(
  'bookmarks$',
  bookmarksList$.pipe(map(toCollectionStream)),
  emptyCollectionStream()
);
